import { LogoutOutlined } from '@ant-design/icons';
import { type ItemType } from 'antd/es/menu/interface';
import { useLogout } from './useLogout.tsx';

interface UseLogoutMenuItemOptions {
  onLogout?: () => void;
}

/**
 * Gestisce il logout dell'utente corrente, sia dalla sessione remota che dai
 * dati locali.
 */
export function useLogoutMenuItem(
  options?: UseLogoutMenuItemOptions,
): ItemType {
  const { onLogout } = options ?? {};
  const { logout, isLoading } = useLogout({
    onLogout,
  });

  if (!logout) return null;

  return {
    key: 'logout-item-menu',
    icon: <LogoutOutlined />,
    label: 'Logout',
    title: 'Effettua il logout',
    disabled: isLoading,
    onClick: () => {
      logout?.();
    },
  };
}
